import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ConvexProvider } from "convex/react";
import { client } from "./convexClient";
import ProtectedRoute from './ProtectedRoute';
import Legal from './Legal.js';
import Profile from './Profile.js';
import MealPlan from './MealPlan.js'
import GroceryList from './GroceryList.js';
import RecipeDetail from './RecipeDetails.js'
import PantryHome from './PantryHome.js';
import WasteDashboard from './WasteDashboard.js';
import Auth2Meal from './Auth2Meal.js';
import IndexMeal2 from './IndexMeal2.js';
import MFASETUPmeal from './MFASETUPmeal.js';
import MFAVerifyMeals from './MFAVerifyMeals.js';
import PricingPageMeals from './PricingPageMeals.js';


//import 
function App() {

  return (
    <div>
      <ConvexProvider client={client}>
    <Router>
        <Routes>
        <Route path="/" element={<IndexMeal2 />} />
        <Route path="/auth" element={<Auth2Meal />} />
        <Route path="/mfa-setup" element={<MFASETUPmeal />} />
        <Route path="/pricingpage" element={<PricingPageMeals />} />
        <Route path="/mfa-verify" element={<MFAVerifyMeals />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/mealplan" element={<MealPlan />} />
        <Route path="/grocery/:userId" element={<GroceryList />} />
        <Route path="/recipe/:userId/:mealName/:suggestionId" element={<RecipeDetail />} />
        <Route path="/pantry/:userId" element={<PantryHome />} />
        <Route path="/wastedashboard/:userId" element={<WasteDashboard />} />
        
        

        <Route path="/privacy" element={<Legal type="privacy" />} />
        <Route path="/terms" element={<Legal type="terms" />} />
        
        </Routes>
    </Router>
    </ConvexProvider>
  </div>
  );
}

export default App;
